import {Component, ElementRef, OnInit, OnDestroy, ViewChild, ViewContainerRef} from '@angular/core';
import {ModalWindowService} from 'src/app/services/ui/modal-window.service';
import { Subscription } from 'rxjs';
import { ModalWindowsTypes } from 'src/app/core/enums';
import { environment } from 'src/environments/environment';
import { NgClass } from '@angular/common';

@Component({
    selector: 'asg-common-modal-window',
    templateUrl: './common-modal-window.component.html',
    styleUrls: ['./common-modal-window.component.scss'],
    standalone: true,
    imports: [NgClass]
})
export class CommonModalWindowComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription = new Subscription();

  public customClass: string | null = null;
  public showCross: boolean = true;
  public showManual: boolean = false;
  public allowedClickingOutside: boolean = true;

  @ViewChild('modalContainer', { read: ViewContainerRef, static: true }) container: ViewContainerRef | null = null;
  @ViewChild('overlay', { read: ElementRef, static: true }) overlay: ElementRef | null = null;
  @ViewChild('modalbody', { read: ElementRef, static: true }) modalbody: ElementRef | null = null;
  constructor(
    private modalService: ModalWindowService,
  ) { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.subToOpen();
    this.subHideCross();
    this.subAllowedClickingOutside();
    this.setModalContainer();
  }

  setModalContainer(): void {
    if (this.container) {
      this.modalService.setModalContainer(this.container);
    }
  }

  public openManual(){
    window.open(environment.manualUrl, "_blank");
  }

  private subToOpen(): void {
    this.subscriptions.add(
      this.modalService.openModal.subscribe(
        (e: { open: boolean, customClass?: string, windowType: ModalWindowsTypes }) => {
          this.showManual = (e.windowType == ModalWindowsTypes.ENTER_ACCESS_CODE_DIALOG);
          if (e.open) {
            this.show();
            this.customClass = e.customClass || '';
          } else {
            this.hide();
          }
        }
      )
    );
  }

  private subHideCross(): void {
    this.subscriptions.add(
      this.modalService.showCross.subscribe((e) => {
        this.showCross = e;
      })
    );
  }

  private subAllowedClickingOutside(): void {
    this.subscriptions.add(
      this.modalService.allowedClickingOutside.subscribe((e) => {
        this.allowedClickingOutside = e;
      })
    );
  }

  addOverLayEventsListener(): void {
    if (this.modalbody) {
      this.modalbody.nativeElement.addEventListener('mousedown', this.clickHandlerFromModal);
    }

    if (this.overlay) {
      this.overlay.nativeElement.addEventListener('mousedown', this.clickHanlderOutsideModal);
    }
  }

  removeEventsListener(): void {
    if (this.modalbody) {
      this.modalbody.nativeElement.removeEventListener('mousedown', this.clickHandlerFromModal);
    }
    if (this.overlay) {
      this.overlay.nativeElement.removeEventListener('mousedown', this.clickHanlderOutsideModal);
    }
  }

  clickHandlerFromModal(e: MouseEvent): void {
    e.stopPropagation();
  }

  private clickHanlderOutsideModal = () => {
    if (this.allowedClickingOutside) {
      this.closeModal();
    }
  }

  closeModal(): void {
    this.modalService.closeByCrossModal();
  }

  show(): void {
    if (this.overlay) {
      this.overlay.nativeElement.style.display = 'block';
    }

    this.addOverLayEventsListener();
  }

  hide(): void {
    if (this.overlay) {
      this.overlay.nativeElement.style.display = 'none';
    }

    this.showCross = true;
    this.allowedClickingOutside = true;
    this.removeEventsListener();
  }
}
